import { useState, useEffect } from "react";
import { url as apiUrl } from "../../api";
import { apiClient } from "../../api/client";

interface Stats {
  totalUsers: number;
  totalFriendsFamilyUsers: number;
  totalAOTD: number;
  totalMessages: number;
  totalTokensUsed: number;
  usersWithTheMostTokens: Array<any>;
  aotdAuthors: Array<any>;
}

interface FastestRecord {
  username: string;
  date: string;
  offsetMs: number;
}

interface FastestRecordYear extends FastestRecord {
  year: number;
}

interface Leaderboard {
  totalAOTD: number;
  aotdAuthors: Array<any>;
  fastestRecordAllTime?: FastestRecord | null;
  fastestRecordYear?: FastestRecordYear | null;
  slowestRecordAllTime?: FastestRecord | null;
  slowestRecordYear?: FastestRecordYear | null;
}

export const useLoadStats = (year: number | null = null) => {
  const url = apiUrl as string; // Add a type assertion here
  const [fetched, setFetched] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [stats, setStats] = useState<Stats>();
  const [leaderboard, setLeaderboard] = useState<Leaderboard>()

  const getAllStats = async () => {
    if (!fetched) {
      setLoading(true);
      try {
        const response = await apiClient.get(`${url}/api/site-stats/full`);
        if (response.status === 200) {
          setStats(response.data as Stats);
          setFetched(true);
          setLoading(false);
        } else {
          console.error("Error fetching full stats:", response.status);
        }
      } catch (error) {
        console.error("Error fetching full stats:", error);
      }
    }
  };

  const getLeaderboard = async () => {
    try {
      // construct the URL with or without year parameter
      const leaderboardUrl = year
        ? `${url}/api/site-stats/leaderboard?year=${year}`
        : `${url}/api/site-stats/leaderboard`;

      const response = await fetch(leaderboardUrl);
      const lbRes = (await response.json()) as Leaderboard;

      if (response.status === 200) {
        setLeaderboard(lbRes);
      } else {
        console.error("Error fetching leaderboard:", response.status);
      }
    } catch (error) {
      console.error("Error fetching leaderboard:", error);
    }
  }

  useEffect(() => {
    getAllStats();
    getLeaderboard();
  }, [url, year]); // add year to dependencies

  return { stats, leaderboard };
};
